import { recordTrack } from '@saucelabs/sl-util-segmentio';

import {
  MAIN_TAB_DEVICES,
  MAIN_TAB_GROUPS,
  MAIN_TAB_INVITATIONS,
  MAIN_TAB_TEAMS,
  MAIN_TAB_USERS,
  SETTINGS_TAB_GENERAL,
  SETTINGS_TAB_SECURITY,
  SETTINGS_TAB_SSO,
} from './constants';

export const CTA_EVENTS = Object.freeze({
  ADD_TEAM_MODAL: Object.freeze({
    SUBMIT: 'cta/add/team-management__team-modal',
  }),
  ADD_GROUP_MODAL: Object.freeze({
    SUBMIT: 'cta/add/team-management__group-modal__submit',
    OPEN: 'cta/add/team-management__group-modal__open',
  }),
  ADD_USER_MODAL: Object.freeze({
    SUBMIT: 'cta/add/team-management__user-modal',
    SUBMIT_INVITE: 'cta/add/team-management__user-modal__invite',
  }),
  ORGANIZATION_DETAILS: Object.freeze({
    COPY_ID: 'cta/click/team-management__organization-key',
    EDIT_NAME: 'cta/click/team-management__organization-name',
  }),
  TEAM_DETAILS: Object.freeze({
    COPY_ID: 'cta/click/team-management__teams__team-key',
    EDIT_NAME: 'cta/click/team-management__teams__team-name',
  }),
  USER_DETAILS: Object.freeze({
    COPY_ID: 'cta/click/team-management__organization-key',
    COPY_ACCESS_KEY: 'org-management/copy/user-access-key',
  }),
});

export const NAVIGATION_EVENTS = Object.freeze({
  MAIN_TABS: Object.freeze({
    [MAIN_TAB_DEVICES]: 'nav/view/team-management__devices',
    [MAIN_TAB_GROUPS]: 'nav/view/team-management__groups',
    [MAIN_TAB_INVITATIONS]: 'nav/view/team-management__invitations',
    [MAIN_TAB_TEAMS]: 'nav/view/team-management__teams',
    [MAIN_TAB_USERS]: 'nav/view/team-management__users',
  }),
  SETTINGS_TABS: Object.freeze({
    [SETTINGS_TAB_GENERAL]: 'nav/view/team-management__settings__general',
    [SETTINGS_TAB_SECURITY]: 'nav/view/team-management__settings__security',
    [SETTINGS_TAB_SSO]: 'nav/view/team-management__settings__sso',
  }),
  GROUP_DETAILS: Object.freeze({
    VIEW_USER_DETAILS: 'nav/view/team-management__group-details__user-details',
  }),
  TEAM_DETAILS: Object.freeze({
    VIEW_USER_DETAILS: 'nav/view/team-management__team-details__user-details',
  }),
  TEAMS_TABLE: Object.freeze({
    VIEW_TEAM_DETAILS: 'nav/view/team-management__teams__details',
  }),
  USERS_TABLE: Object.freeze({
    VIEW_USER_DETAILS: 'nav/view/team-management__users__details',
  }),
  VIEW_SETTINGS: 'nav/view/team-management__settings',
});

export const SETTINGS_EVENTS = Object.freeze({
  SECURITY_SETTINGS_WIKI: 'docs/click/org-mgmt__settings__security__security-settings-link',
});

export const trackEvent = recordTrack;
export default trackEvent;
